import { useQuery } from '@pinia/colada';
import { MaybeRefOrGetter, toValue } from 'vue';

import { useCompanyQuery } from '@tallo/investor/company';
import { TimeFilter } from '@tallo/utility';

import { ShowingStatus } from '../interfaces/showing-status.enum';
import showingsService from '../services/showings.service';

export const showingsQueryKey = 'showings';

export function useShowingsQuery({
  onlyWithPendingShowingReqests,
  timeFilter,
  propertyId,
  renterId,
  status,
}: {
  onlyWithPendingShowingReqests?: boolean;
  timeFilter?: MaybeRefOrGetter<TimeFilter>;
  propertyId?: MaybeRefOrGetter<string>;
  renterId?: MaybeRefOrGetter<string | undefined>;
  status?: MaybeRefOrGetter<ShowingStatus | undefined>;
} = {}) {
  return useQuery({
    key: () => {
      const queryKey = [showingsQueryKey];
      const timeFilterValue = toValue(timeFilter);
      const propertyIdValue = toValue(propertyId);
      const renterIdValue = toValue(renterId);
      const statusValue = toValue(status);

      if (onlyWithPendingShowingReqests) {
        queryKey.push('onlyWithPendingShowingReqests');
      }

      if (timeFilterValue) {
        queryKey.push(`timeFilter:${timeFilterValue}`);
      }

      if (propertyIdValue) {
        queryKey.push(`propertyId:${propertyIdValue}`);
      }

      if (renterIdValue) {
        queryKey.push(`renterId:${renterIdValue}`);
      }

      if (statusValue) {
        queryKey.push(`status:${statusValue}`);
      }

      return queryKey;
    },
    query: async () => {
      const companyQuery = useCompanyQuery();
      const { data } = await companyQuery.refresh(true);

      return showingsService.getShowingsByCompany(data?.id as string, {
        onlyWithPendingShowingReqests,
        timeFilter: toValue(timeFilter),
        propertyId: toValue(propertyId),
        renterId: toValue(renterId),
        status: toValue(status),
      });
    },
  });
}
